import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const modifyOrganization = organizationData => {
  return dispatch => {
    dispatch({ type: "MODIFY_ORGANIZATION_LOADING" });
    api
      .organizationPost(organizationData)
      .then(resp => {
        dispatch(postEditSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "ModifyOrganizationErrorAlertTitle",
          "Virhe yritystietojen muuttamisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const postEditSucceeded = data => ({
  type: "MODIFY_ORGANIZATION_EDIT_SUCCEEDED",
  payload: { organization: data },
});

const operationFail = () => ({
  type: "MODIFY_ORGANIZATION_FAIL"
});